import { isDefined } from "csi/utility/coreUtility";
import { Box, FlexColumn, TextField } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import css from "./CustomViewOptions.module.css";

const PrintOptionFontScale: FunctionComponent = observer(function PrintOptionFontScale() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		hasPrintFontScaleValidationError,
		options: {
			printAutoScale,
			printFontScale,
		},
		printOptionFontScaleTextDefaultValue,
		printOptionFontScaleValidationMsg,
		setPrintFontScale,
	} = optionsStore;

	return (
		<>
			{isDefined(printFontScale) && !printAutoScale && (
				<Box className={css.container}>
					<FlexColumn className={css.optionLeft}>
						<TextField
							defaultValue={printOptionFontScaleTextDefaultValue}
							error={hasPrintFontScaleValidationError}
							helperText={printOptionFontScaleValidationMsg}
							onChange={setPrintFontScale}
							placeholder=""
							res="CustomViewPrintFontScale"
							style={{
								paddingBottom: 28,
							}}
						/>
					</FlexColumn>
				</Box>
			)}
		</>
	);
});

export default PrintOptionFontScale;